import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import ShareButton from './ShareButton';
import { generateTestId } from 'app/functions';

const ButtonWrapper = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  top: 'auto',
  width: '100%',
  transform: 'none',
  zIndex: 1000,
  background: theme.palette.background.paper,
  borderRadius: '32px 32px 0px 0px',
  padding: '20px 14px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px',
  boxShadow: '0px 0px 40px 0px rgba(0, 44, 87, 0.16)',
  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));

const ButtonsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  gap: '20px',
  justifyContent: 'center',
  alignItems: 'center',
}));

const ShareButtonWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '& img, & svg': {
    width: '40px !important',
    height: '40px !important',
    fontSize: '20px !important',
  },
  '& > div > div': {
    maxWidth: '80px !important',
  },
  '& button': {
    width: 'auto !important',
    height: 'auto !important',
  },
}));

const FixedShareButton = ({
  canShare,
  isMobile,
  theme,
  popupContent,
  whatsAppImage,
  smsImage,
  emailImage,
  copyImage,
  shareImage,
  translations,
  handleCopyLink,
  handleShareClick,
  handleWhatsappShareClick,
  handleEmailShareClick,
  handleSmsShareClick,
  toastOpen,
  setToastOpen,
  getCopyButtonTooltipProps,
  testID = 'fixed-share-button',
}) => {
  if (!isMobile) return null;

  return (
    <ButtonWrapper testid={generateTestId(testID, 'wrapper')}>
      <ButtonsContainer testid={generateTestId(testID, 'buttons-container')}>
        <ShareButtonWrapper>
          <ShareButton
            type="copy"
            iconImage={copyImage}
            onClick={handleCopyLink}
            isMobile={isMobile}
            theme={theme}
            color={theme.palette.primary?.main}
            label={popupContent?.copyLabel || 'העתק קישור'}
            tooltipContent={translations?.link_copy_success || 'הקישור הועתק בהצלחה'}
            tooltipOpen={toastOpen}
            onTooltipClose={() => setToastOpen(false)}
            tooltipPlacement="top"
            canShare={canShare}
            tooltipProps={getCopyButtonTooltipProps(theme, isMobile)}
            testID={generateTestId(testID, 'copy-button')}
          />
        </ShareButtonWrapper>
        {canShare && (
          <ShareButtonWrapper>
            <ShareButton
              type="share"
              iconImage={shareImage}
              onClick={handleShareClick}
              isMobile={isMobile}
              theme={theme}
              label={popupContent?.shareLabel || 'שתף'}
              color={theme.palette?.primary?.blue}
              canShare={canShare}
              testID={generateTestId(testID, 'share-button')}
            />
          </ShareButtonWrapper>
        )}
        {!canShare && (
          <>
            <ShareButtonWrapper>
              <ShareButton
                type="whatsapp"
                iconImage={whatsAppImage}
                onClick={handleWhatsappShareClick}
                isMobile={isMobile}
                theme={theme}
                label={popupContent?.whatsappLabel || 'וואטסאפ'}
                color={theme.palette.primary?.main}
                canShare={canShare}
                testID={generateTestId(testID, 'whatsapp-button')}
              />
            </ShareButtonWrapper>
            <ShareButtonWrapper>
              <ShareButton
                type="email"
                iconImage={emailImage}
                onClick={handleEmailShareClick}
                isMobile={isMobile}
                theme={theme}
                label={popupContent?.emailLabel || 'אימייל'}
                color={theme.palette.primary?.main}
                canShare={canShare}
                testID={generateTestId(testID, 'email-button')}
              />
            </ShareButtonWrapper>
            <ShareButtonWrapper>
              <ShareButton
                type="sms"
                iconImage={smsImage}
                onClick={handleSmsShareClick}
                isMobile={isMobile}
                theme={theme}
                label={popupContent?.smsLabel || 'SMS'}
                color={theme.palette.primary?.main}
                canShare={canShare}
                testID={generateTestId(testID, 'sms-button')}
              />
            </ShareButtonWrapper>
          </>
        )}
      </ButtonsContainer>
    </ButtonWrapper>
  );
};

export default FixedShareButton;

